@if (projectOutcome) {
  <div class="outcome">
    <div class="row">
      <div class="col-md-12 outcome-detail-panel">
        <div class="number-panel">
          <div>
                    <span class="btn hub-round-button rounded-round btn-icon btn-sm legitRipple mr-3" [ngClass]="{'focused-metric': projectOutcome.outcome.outcomeMetric.isFocused,
                                    'non-focused-metric': !projectOutcome.outcome.outcomeMetric.isFocused }">
              <span class="letter-icon">{{outcomeIndex + indexOffset + 1}}</span>
            </span>
          </div>
        </div>
        <div class="left-panel">
          <div class="title">
            <div class="hub-unique-id-panel">
              <span class="hub-unique-id">{{projectOutcome.outcome.uniqueId}}</span>
            </div>
                    <h5 [ngClass]="{'focused-metric': projectOutcome.outcome.outcomeMetric.isFocused,
                                    'non-focused-metric': !projectOutcome.outcome.outcomeMetric.isFocused }">
              <span class="font-weight-bold">Outcome - </span> {{projectOutcome.outcome.outcomeMetric.name}}
              <span class="text-muted font-size-sm">({{projectOutcome.outcome.outcomeUnit.name}})</span>
            </h5>
          </div>
          @if (projectOutcome.isPolicyLeverageOutcome) {
            <div class="mt-1 mb-1">
              <span class="font-weight-bold" style="color: #018899;">Leverage Outcome: </span>
              <span class="text-muted">Policy</span>
            </div>
          }
          <p class="record-description">{{projectOutcome.statement}}</p>
          @if (projectOutcome.outcome.parentOutcome) {
            <div>
              <div class="text-indigo-300"><i class="align-baseline mr-1 icon-tree7"></i>
              <span class="font-weight-bold">Linked to: </span>
              <span>Strategy Outcome </span>
              <span class="font-weight-bold">{{projectOutcome.outcome.parentOutcome.uniqueId}} </span>
              <span>{{projectOutcome.outcome.parentOutcomeProjectName}}</span>
            </div>
          </div>
        }
      </div>
      <div class="right-panel">
        <div>
          @if (projectOutcome.outcomeStatistics.hasTargets || projectOutcome.outcomeStatistics.hasProgress) {
            <div
              >
              <mat-checkbox [(ngModel)]="areDetailsShowing" color="primary">Show Details</mat-checkbox>
            </div>
          }
          <!-- PROGRESS BAR -->
          @if (projectOutcome.outcomeStatistics.hasTargets) {
            <div>
              <div class="progress mt-1 mb-2" style="height: 0.5rem;">
                <div class="progress-bar bg-success"
                  [style.width.%]="projectOutcome.outcomeStatistics.totalProgressPercent * 100">
                </div>
              </div>
              @if (projectOutcome.outcomeStatistics.lastTargetValue !== 0) {
                <div>
                  <span class="font-weight-bold">
                  {{projectOutcome.outcomeStatistics.totalProgressPercent | percent}}</span> achieved
                  towards target of
                  <span class="font-weight-bold">{{projectOutcome.outcomeStatistics.lastTargetValue | number:
                    '0.0-0'}}
                  {{projectOutcome.outcome.outcomeUnit.name}}</span>
                  @if (projectOutcome.selectedMetricOptionUnit !== projectOutcome.reportingMetricOptionUnitName) {
                    <span
                      style="color: darkgray"> ({{projectOutcome.outcomeStatistics.lastTargetValue | number:
                      '0.0-0'}}
                    {{outcome.reportingUnitName}})</span>
                  }
                </div>
              }
            </div>
          }
          @if (projectOutcome.outcome.outcomeMetricId !== climateMitigationMetricDbId) {
            <div style="margin-top: 10px;" [innerHtml]="getCurrentPeriodProgressInfo(projectOutcome)">
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- OUTCOME DETAILS TABLE -->

@if (areDetailsShowing) {
  <div class="row pl-5 pr-3" #detailsPanel style="margin-top: 10px;">
    @if (!detailsLoading) {
      <div class="col-md-12">
        <div class="hub-detail-header-panel">
          <h5 class="text-success">Outcome Start, Progress and Target Values</h5>
          @if (isShowOutcomeCharacteristicsVisible) {
            <mat-checkbox [(ngModel)]="areOutcomeCharacteristicsShowing"
            color="primary">Show Outcome Characteristics</mat-checkbox>
          }
        </div>
        <div class="table-responsive mb-2 mr-3">
          <table class="table table-bordered table-border-dashed metric-table">
            <thead>
              <tr class="table-border-double">
                <th class="text-right" width="5%">ID</th>
                <th width="15%" class="text-right">Value Type</th>
                <th width="20%" class="text-right">Date</th>
                <th class="text-right">Value</th>
              </tr>
            </thead>
            @for (target of projectOutcome.targets; track target) {
              <tbody>
                <tr>
                  <td class="text-right">
                    <div class="hub-unique-id-panel">
                      <span class="hub-unique-id">{{target.uniqueId}}</span>
                    </div>
                  </td>
                  <td class="text-right">
                    <span class="date-label text-success">Target</span>
                  </td>
                  <td class="text-right">
                    <span class="d-block">
                      {{target.targetDate | date}}
                    </span>
                  </td>
                  <td class="text-right">
                    <div class="value-line">
                      <span class="value">
                        {{target.targetValue | number: '1.0-0'}}
                      </span>
                      <span class="unit">
                        {{projectOutcome.outcome.outcomeUnit.name}}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            }
            @for (outcomeProgress of cummulativeProgress; track outcomeProgress) {
              <tbody>
                <tr>
                  <td class="text-right">
                    <div class="hub-unique-id-panel">
                      <span class="hub-unique-id">{{outcomeProgress.uniqueId}}</span>
                    </div>
                  </td>
                  @if (outcomeProgress.isStart) {
                    <td class="text-right">
                      <span class="date-label text-primary">Start</span>
                    </td>
                  }
                  @if (!outcomeProgress.isStart) {
                    <td class="text-right">
                      <span class="date-label text-dark">Progress</span>
                    </td>
                  }
                  <td class="text-right">
                    <span class="d-block">
                      {{outcomeProgress.progressDate | date}}
                    </span>
                  </td>
                  <td class="text-right">
                    @if (!isStrategy || doUnitsMatch(projectOutcome, outcomeProgress)) {
                      <div class="value-line">
                        <span class="value">
                          {{outcomeProgress.progressValue | number: '1.0-0'}}
                        </span>
                        <span class="unit">
                          {{projectOutcome.outcome.outcomeUnit.name}}
                        </span>
                      </div>
                    } @else {
                      <div class="value-line">
                        <span class="value">
                          {{convertToParentUnit(outcomeProgress) | number: '1.0-0'}}
                        </span>
                        <span class="unit">
                          {{projectOutcome.outcome.outcomeUnit.name}}
                        </span>
                      </div>
                      <div class="value-line entry-unit">
                        <span class="value">
                          (
                          {{outcomeProgress.progressValue | number: '1.0-0'}}
                        </span>
                        <span class="unit">
                          {{outcomeProgress.outcomeUnit.name}}
                          )
                        </span>
                      </div>
                    }
                    @if (isStrategy) {
                      <div class="mt-1">
                        <a class="badge-primary badge font-size-lg"
                        [routerLink]="'/portfolio/' + outcomeProgress.childProjectId">{{outcomeProgress.childProjectName}}</a>
                      </div>
                    }
                    @if (!isStrategy) {
                      <div>
                        <div class="attribution">
                          <span>{{outcomeProgress.attributionLevel?.name}}</span>
                        </div>
                        <div class="attribution-text">
                          {{outcomeProgress.attributionDescription}}
                        </div>
                      </div>
                    }
                    @if (areOutcomeCharacteristicsShowing) {
                      @for (outcomeProgressAttribute of outcomeProgress.outcomeProgressAttributes; track outcomeProgressAttribute) {
                        <div>
                          <span
                            class="attribution">{{getAttributeLabel(outcomeProgressAttribute.outcomeListId)}}:
                          </span>
                          <span
                          class="attribution-text">{{getAttributeValue(outcomeProgressAttribute)}}</span>
                        </div>
                      }
                    }
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
      </div>
    }
    @if (detailsLoading) {
      <app-modal-spinner></app-modal-spinner>
    }
  </div>
}
